@import "~@sydle/sydle-ui/styles/scss/breakpoints/index";

// @import '../../../node_modules/@sydle/sydle-ui/styles/scss/breakpoints/index.scss';

:host {
  display: block;

  --sy-text-h2-font-size: 32px;
  --sy-text-h3-font-size: 28px;
  --sy-text-body-font-size: 16px;

  sy-text {
    margin: 0;
  }

  .flex-align {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .background-1 {
    --background-image: var(--background-image-vertical-url, unset);

    background: var(--background-color, var(--background-image));
    border: solid 1px var(--sy-accent);

    @include breakpoint-media-up(lg) {
      --background-image: var(--background-image-horizontal-url);
    }
  }

  .background-2 {
    padding: 32px;
  }

  .background-1,
  .background-2 {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background-size: cover;
  }

  .cover {
    width: 100%;
    height: 100%;

    .inner-content {
      gap: 20px;
    }

    sy-button {
      --sy-button-padding: 16px 32px;
      --sy-button-width: 100%;
    }
  }

  .shadow {
    position: absolute;
    width: 100%;
    height: 10px;

    &.top {
      top: 0;
      background:
        radial-gradient(
          farthest-side at 50% 0,
          rgb(0 0 0 / 20%),
          rgb(0 0 0 / 0%)
        ) center top;
      opacity: 0;
    }

    &.bottom {
      bottom: 0;
      background:
        radial-gradient(
          farthest-side at 50% 100%,
          rgb(0 0 0 / 20%),
          rgb(0 0 0 / 0%)
        ) center bottom;
      opacity: 0;
    }
  }

  #quiz-form {
    overflow-y: auto;

    .shadow-body {
      position: relative;
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }

    #question-body {
      max-height: 100%;
      overflow-y: auto;

      sy-text {
        white-space: pre-wrap;
      }
    }

    @include breakpoint-media-up(lg) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: min-content auto;
      overflow-y: visible;

      .toolbar {
        grid-column: 1 / 3;
      }
    }
  }

  .toolbar {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .paginator {
      display: flex;
      align-items: flex-start;

      .inner {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
  }

  .anwser-buttons {
    width: 100%;
    gap: 8px;

    sy-button {
      width: 100%;

      --sy-font-size: 1rem;
      --sy-button-padding: .4rem 1.8rem;
      --sy-button-line-height: 24px;
      --sy-button-border-color: var(--sy-accent);
      --sy-button-color: var(--sy-accent);
      --sy-button-background-color: transparent;
    }
  }

  .quiz-answered {
    --sy-button-padding: 16px 32px;
    --sy-button-width: 100%;
  }

  .quiz-answer {
    max-height: 100%;

    .final-text {
      align-self: flex-start;
      overflow-y: auto;
      white-space: pre-wrap;
    }
  }
}
